module.exports = __webpack_public_path__ + "img/icon-22-gr.7069ddbb.svg";